import axios, { AxiosInstance } from 'axios'

const API_URL = (process.env.VUE_APP_API_URL || 'https://localhost:5001/api').trim()

export const AxiosClient: AxiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: false
})
